<template>
  <v-dialog
    ref="dialog"
    v-model="value"
    :persistent="persistent"
    :max-width="maxWidth"
    :fullscreen="fullscreen"
    data-testid="dialog"
    scrollable
    :class="{ shrinkable: shrinkable }"
  >
    <v-card
      ref="dialog-card"
      :loading="loading"
      class="pa-4"
      data-testid="dialog-card"
    >
      <div class="title-bar d-flex align-center">
        <h4
          v-if="cardTitle || $slots.title"
          ref="dialog-card-title"
          class="title-text pa-4"
          data-testid="dialog-card-title"
        >
          {{ cardTitle }}
          <slot name="title"></slot>
        </h4>
        <v-card-actions class="pa-0">
          <v-btn
            v-if="!persistent"
            icon="$close"
            variant="plain"
            class="align-self-start"
            data-testid="dialog-close-button"
            @click.stop="onClose"
          ></v-btn>
        </v-card-actions>
      </div>
      <v-card-text :class="shrinkable ? 'pa-0' : 'pa-4'">
        <slot></slot>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
  import { defineComponent } from "vue"

  export default defineComponent({
    props: {
      modelValue: {
        type: Boolean,
        default: false,
      },
      cardTitle: {
        type: String,
        required: false,
        default: null,
      },
      persistent: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      maxWidth: {
        type: [Number, String],
        default: 800,
      },
      shrinkable: {
        type: Boolean,
        default: false,
      },
      fullscreen: {
        type: Boolean,
        default: false,
      },
    },
    emits: ["update:modelValue", "onClose"],
    computed: {
      value: {
        get() {
          return this.modelValue
        },
        set(value: boolean) {
          this.$emit("update:modelValue", value)
        },
      },
    },
    watch: {
      value(val) {
        if (!val) {
          // event triggers after close animation
          setTimeout(() => {
            this.$emit("onClose")
          }, 150)
        }
      },
    },
    methods: {
      onClose() {
        this.value = false
      },
    },
  })
</script>

<style lang="css" scoped>
  .title-bar {
    display: flex;
    justify-content: end;
  }
  .title-text {
    white-space: normal;
    flex-grow: 1;
    flex-shrink: 1;
  }

  :deep(.v-overlay__content) {
    overflow: visible !important;
  }

  .shrinkable :deep(.v-overlay__content) {
    width: auto;
  }
</style>
